import { Center, Container, Image, Text, VStack } from '@chakra-ui/react';

function RequestParcelExpiration() {
  return (
    <Center px={'16px'} h={'100%'}>
      <VStack gap={0} h={'100%'} justifyContent={'center'}>
        <Image src="/assets/images/icn_exclaim_circle.svg" boxSize={'56px'} />
        <Text
          fontSize={'22px'}
          fontWeight="semibold"
          color={'#000000'}
          mt={'16px'}>
          운송장 등록 링크가 만료되었습니다.
        </Text>
        <Text
          fontSize={'14px'}
          fontWeight="semibold"
          color={'#757575'}
          mt={'12px'}>
          제품도착, 접수취소 등으로 만료된 요청입니다.
        </Text>
      </VStack>
    </Center>
  );
}

export default RequestParcelExpiration;
